export const DUTCHIEPAY = 'dutchiePay';
export const MANUAL_PAY_BY_BANK_FINALIZATION_FLAG = 'fintech.retail-payments.pbb-manual-finalization.rollout';

export const PBB_IDENTITY_CHANGED_FIELDS = ['birthday', 'email', 'first_name', 'last_name', 'phone'] as const;
export const PBB_UNENROLLMENT_REASONS = [
  'account_profile_update',
  'checkout_profile_update',
  'consumer_explicit_unlink',
] as const;
export const PBB_UNENROLLMENT_SURFACES = ['bank_account', 'checkout', 'my_account'] as const;

// ERRORS
export const dutchiePayErrorCodes = {
  S002: 'S002',
  B104: 'B104',
  B105: 'B105',
} as const;

export const getDutchiePayError = (code?: string): string => {
  if (!code) {
    return 'We were unable to authorize this payment through Pay by Bank.';
  }
  // the **[text]** will be read by React-markup and make the text bold
  let errorMessage = `Pay by Bank is unavailable. Please use a different method of payment. **${code}.**`;

  if (code === dutchiePayErrorCodes.B104) {
    errorMessage = `Your bank account has insufficient funds to complete this transaction. Please either use a different method of payment or add funds to your bank account and try again. **${code}.**`;
  }

  if (code === dutchiePayErrorCodes.B105) {
    errorMessage = `Your bank account is unlinked. **${code}.**`;
  }

  return errorMessage;
};

export const StatusTypes = {
  statusAcceptTerms: 'STATUS_ACCEPT_TERMS',
  statusAccountDisconnected: 'STATUS_ACCOUNT_DISCONNECTED',
  statusAccountPending: 'STATUS_ACCOUNT_PENDING',
  statusAggregatorError: 'STATUS_AGGREGATOR_ERROR',
  statusEnrolled: 'STATUS_ENROLLED',
  statusNoAccount: 'STATUS_NO_ACCOUNT',
  statusUnenrolled: 'STATUS_UNENROLLED',
  statusUnspecified: 'STATUS_UNSPECIFIED',
} as const;
